var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25116",
    "data-name": "Rectangle 25116",
    width: 20,
    height: 20,
    transform: "translate(-0.4)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_86208",
    "data-name": "Group 86208",
    transform: "translate(0.201)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_86207",
    "data-name": "Group 86207",
    transform: "translate(0.199)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_242485",
    "data-name": "Path 242485",
    d: "M9.915,0a9.915,9.915,0,1,0,9.915,9.915A9.926,9.926,0,0,0,9.915,0m0,18.294a8.379,8.379,0,1,1,8.379-8.379,8.389,8.389,0,0,1-8.379,8.379",
    transform: "translate(-0.23)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242486",
    "data-name": "Path 242486",
    d: "M13.8,9.123H10.729V6.051a.768.768,0,1,0-1.537,0V9.123H6.12a.768.768,0,1,0,0,1.536H9.192v3.073a.768.768,0,0,0,1.537,0V10.659H13.8a.768.768,0,1,0,0-1.536Z",
    transform: "translate(-0.275 -0.045)",
    fill: "#fd930d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.1d7e8664b06219204a33f79477ea11c5.svg";
export { ForwardRef as ReactComponent };